export const SET_BULKUPLOADFILES = "SET_BULKUPLOADFILES";
export const GET_BULKUPLOADFLAG = 'GET_BULKUPLOADFLAG';
export const SET_BULKUPLOADFLAG = 'SET_BULKUPLOADFLAG';
export const SET_BULKUPLOADERROR = 'SET_BULKUPLOADERROR';
